export function debugLog(name) {
  window.ksLog && window.ksLog.sendCountTag("mobilePay_Result_".concat(name));
}